"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPath = styled_components_1.default.path `
  fill: ${({ theme, color }) => color || theme.palette.red[50]};
`;
const PhoneIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)(StyledPath, { clipRule: "evenodd", color: rest.color, d: "M12.144 2C17.59 2 22 6.413 22 11.862h-1.876a7.979 7.979 0 00-7.98-7.985V2z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)(StyledPath, { clipRule: "evenodd", color: rest.color, d: "M12.144 6.293a5.573 5.573 0 015.566 5.57h-1.876a3.696 3.696 0 00-3.69-3.693V6.293z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "M6.628 17.368c7.918 7.923 14.222 3.705 14.822 1.728l-6.266-4.569-2.64 2.641c-1.15-.726-4.99-4.555-5.716-5.72l2.64-2.64-4.566-6.27c-1.976.6-6.191 6.92 1.726 14.83z" })] }));
exports.default = (0, IconContainer_1.default)(PhoneIcon);
//# sourceMappingURL=index.js.map